"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".zoom-button[_ngcontent-%COMP%] {\n  bottom: 32px;\n  right: 6px;\n  position: absolute; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL01hcHNlbmRlciA0RCBSZWxlYXNlL3dlYnNpdGUvc3JjL2FwcC9tYWluL21hcC9jYW1lcmEtbmF2LmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0ksYUFBWTtFQUNaLFdBQVU7RUFDVixtQkFBa0IsRUFDbkIiLCJmaWxlIjoic3JjL2FwcC9tYWluL21hcC9jYW1lcmEtbmF2LmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLnpvb20tYnV0dG9uIHtcbiAgICBib3R0b206IDMycHg7XG4gICAgcmlnaHQ6IDZweDtcbiAgICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIH1cbiJdfQ== */"];
exports.styles = styles;
